import { useEffect } from 'react';
import useModalState from '@sdk/components/ui/modal/useModalState';
import useAuth from '@sdk/authentication/useAuth';
import { RoleType } from '@sdk/authentication/types';

import { useShouldShow } from '@web/common/hooks/useShouldShow';

const DISPLAY_AFTER_MS = 1000 * 5;
const DELAY_IN_MINUTES = 30 * 24 * 60;

export const useActivityLogAnnouncement = () => {
  const { isVisible, open, close } = useModalState();

  const { currentUser } = useAuth();
  const { dontShowAgain, shouldShow } = useShouldShow('activityLogAnnouncement', currentUser, {
    delayInMinutes: DELAY_IN_MINUTES,
    roles: [RoleType.manager, RoleType.admin],
  });

  const dismiss = () => {
    dontShowAgain();
    close();
  };

  const shouldBeShown = currentUser && shouldShow();

  useEffect(() => {
    if (shouldBeShown && !isVisible) {
      setTimeout(open, DISPLAY_AFTER_MS);
    }
  }, []);

  return {
    dismiss,
    isVisible,
    close,
    shouldBeShown,
  };
};
